module.exports = __webpack_public_path__ + "static/media/logo-lemedia-gradient.a0513464.svg";